var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 41,
    viewBox: "0 0 61 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4629 0.0310059V40.031H0.462891V29.3981L22.4629 6.10696L40.4629 12.1829L60.4629 0.0310059Z",
    fill: "url(#paint0_linear_1453_2778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4629 10.1255L39.3229 23.5794L22.4629 12.1187L0.462891 8.13232V39.5247H60.4629V10.1255Z",
    fill: "url(#paint1_linear_1453_2778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.462891 40.031H60.4629",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1453_2778",
    x1: 30.4629,
    y1: 0.0310059,
    x2: 30.4629,
    y2: 40.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0298A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0298A6",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1453_2778",
    x1: 30.4629,
    y1: 8.13232,
    x2: 30.4629,
    y2: 39.5247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003F7F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.2e43aa75650cf88883f598669e575151.svg";
export { ForwardRef as ReactComponent };